import { ORDER_CREATE, ORDER_ERROR, ORDER_SUCCESS } from '../actions/order'
import Vue from 'vue'
import api from '../../components/Orders/api'
const state = { customerId:'',currency:'' }

const getters = {
  //  OrderStatus: state => state.order.status,
    getOrder: state => state.order
  }
  const actions = {
    [ORDER_CREATE]: ({commit, dispatch},order) => {
        return new Promise((resolve, reject) => {
            console.log('store ORDER_CREATE',order)
     // commit(ORDER_CREATE)
      console.log('store create order')
      commit(ORDER_SUCCESS, order)
      
     /*  api.createOrder(order)
        .then(resp => {
          console.log('store response ',resp)
          commit(ORDER_SUCCESS, resp)
            resolve(resp)
        })
        .catch(resp => {
            
          commit(ORDER_ERROR)
          reject(resp)
          // if resp is unauthorized, logout, to
          //dispatch(AUTH_LOGOUT)
        }) */
    })
    }
}
const mutations = {
    [ORDER_SUCCESS]: (state,resp) => {
        console.log('Mutation')
       state.customerId=resp.customerId
       state.currency=resp.currency
    }
}
export default {
    state,
    getters,
    actions,
   mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/order.js